
<!-- <header class="navpage-header"  role="banner" style="background-color:#1d1d1d"> -->
  <div class="navbar navbar-default navpage-header" style="background-color:#1d1d1d" >
    <div class="container-fluid" >
      <div class="navbar-header" nav-banner-logo="">
        
        <a class="navbar-brand" 
        >
        <img id="mainBannerImage16"
         src="assets/img/EY_Logo.png" style="height: 20px; " aria-hidden="true">
          <span class="sr-only">ServiceNow Home Page</span></a>
          <span class="banner-text h4" style="color: white;">IN Talent Help Desk</span>
      </div>
    </div>
    </div>

  <div class="content-wrapper">
      <div class="container">
          <div class="container-fluid" style="padding-top: 150px;">
              <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 logout-body">
                      <div class="row" style="margin-left: 20rem;">
                          <div class="col-md-2" style="margin-top: 35px;">
                              <i class="pi pi-exclamation-triangle" style="color: green; font-size: 5.5rem;"></i>

                          </div>
                          <div class="col-md-10 text-left" style="margin-top: 25px;">
                              <p style="word-wrap:break-word; width:500px">{{ErrorMessage}}</p>
                              <h5>You have been logged out from this application.</h5>
                              <span style="text-decoration: underline"><a (click)="Login()"
                                      style="cursor:pointer;">Please Click Here to Re-login</a> </span>
                          </div>
                      </div>
                  </div>
              </div>

          </div>
      </div>

</div>